export default __webpack_public_path__ + "static/nrg-logo-h100px-c35310710165d29b02eca1297639b8d5.png";